/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from './icon.component';
const styles_IconComponent:any[] = ([] as any[]);
export const RenderType_IconComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_IconComponent,
  data: {}
}
);
export function View_IconComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,':svg:svg',[
      [
        'class',
        'icon-svg'
      ]
      ,
      [
        'xmlns',
        'http://www.w3.org/2000/svg'
      ]

    ]
      ,[[
        2,
        'grunge',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:use',([] as any[]),[[
        1,
        ':xlink:href',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(null as any),(ck,v) => {
    var co:import1.IconComponent = v.component;
    const currVal_0:any = co.grunge;
    ck(v,0,0,currVal_0);
    const currVal_1:any = ('#' + co.name);
    ck(v,2,0,currVal_1);
  });
}
function View_IconComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon',([] as any[]),(null as any),(null as any),(null as any),View_IconComponent_0,RenderType_IconComponent)),
    import0.ɵdid(573440,(null as any),0,import1.IconComponent,[import0.ChangeDetectorRef],(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const IconComponentNgFactory:import0.ComponentFactory<import1.IconComponent> = import0.ɵccf('woa-icon',import1.IconComponent,View_IconComponent_Host_0,{
  name: 'name',
  grunge: 'grunge'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvdWktZWxlbWVudHMvaWNvbi9pY29uLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3J1bm5lci93b3JrL3dlYi1vcmRlcmluZy1hcHAvd2ViLW9yZGVyaW5nLWFwcC9zcmMvYXBwL3VpLWVsZW1lbnRzL2ljb24vaWNvbi5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL3J1bm5lci93b3JrL3dlYi1vcmRlcmluZy1hcHAvd2ViLW9yZGVyaW5nLWFwcC9zcmMvYXBwL3VpLWVsZW1lbnRzL2ljb24vaWNvbi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvdWktZWxlbWVudHMvaWNvbi9pY29uLmNvbXBvbmVudC50cy5JY29uQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHN2ZyBjbGFzcz1cImljb24tc3ZnXCIgW2NsYXNzLmdydW5nZV09XCJncnVuZ2VcIiB4bWxucz1cImh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnXCI+XG4gICAgPHVzZSBbYXR0ci54bGluazpocmVmXT1cIicjJyArIG5hbWVcIj48L3VzZT5cbjwvc3ZnPlxuIiwiPHdvYS1pY29uPjwvd29hLWljb24+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQ0FBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7T0FBQTtRQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBaUY7TUFDN0U7UUFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQTBDO0lBQ3hDOzs7O0lBRmdCO0lBQXRCLFNBQXNCLFNBQXRCO0lBQ1M7SUFBTCxTQUFLLFNBQUw7Ozs7O0lDREo7Z0JBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/app/ui-elements/icon/icon.component.ngfactory.ts